import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

/** Iter 173 · Poll a bg_jobs entry until it terminates.
 *  Returns { job, refresh }. Job is null until first fetch. */
export function useJobPoller(wsId, jobId, intervalMs = 2500) {
  const [job, setJob] = useState(null);
  const timerRef = useRef();

  const fetchOnce = async () => {
    if (!wsId || !jobId) return;
    try {
      const r = await api.get(`/workspaces/${wsId}/jobs/${jobId}`);
      setJob(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    setJob(null);
    if (!wsId || !jobId) return undefined;
    let cancelled = false;
    const tick = async () => {
      const j = await fetchOnce();
      if (cancelled) return;
      if (j && (j.status === "done" || j.status === "failed"
                || j.status === "partial")) {
        return; // terminal — stop polling
      }
      timerRef.current = setTimeout(tick, intervalMs);
    };
    tick();
    return () => {
      cancelled = true;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [wsId, jobId, intervalMs]);

  return { job, refresh: fetchOnce };
}
